<script setup lang="ts">
import { services } from '~/data/services'
import type { Locale } from '~/data/types'

const { t, locale } = useI18n()
const localePath = useLocalePath()
const lc = computed(() => locale.value as Locale)
const crumbs = usePageMeta('services')
</script>

<template>
  <div>
    <PageHeader
      :title="t('services.title')"
      :lead="t('services.lead')"
      :crumbs="crumbs"
    />
    <section class="section container-site pt-6">
      <ul class="grid grid-lines sm:grid-cols-2 lg:grid-cols-3">
        <li
          v-for="s in services"
          :key="s.key"
          class="bg-white"
        >
          <NuxtLink
            :to="localePath({ name: 'leistungen-slug', params: { slug: s.slug[lc] } })"
            class="group flex h-full flex-col gap-4 p-8 transition-colors hover:bg-sky"
          >
            <Icon
              :name="s.icon"
              class="text-[2rem] text-brand-deep"
              aria-hidden="true"
            />
            <h2 class="text-xl leading-snug">
              {{ s.title[lc] }}
            </h2>
            <p>{{ s.summary[lc] }}</p>
            <span class="mt-auto inline-flex items-center gap-2 pt-2 font-semibold text-ink">
              <span class="underline decoration-brand decoration-2 underline-offset-4 group-hover:decoration-ink">{{ t('services.more', { title: s.title[lc] }) }}</span>
            </span>
          </NuxtLink>
        </li>
      </ul>
    </section>
    <section class="bg-brand section">
      <div class="container-site grid items-center gap-8 lg:grid-cols-[1fr_1.2fr]">
        <h2 class="text-[clamp(1.75rem,4vw,2.75rem)] leading-tight">
          {{ t('services.agencyTitle') }}
        </h2>
        <div class="space-y-6 text-lg text-ink">
          <p>{{ t('services.agencyText') }}</p>
          <NuxtLink
            :to="localePath('/kontakt')"
            class="btn"
          >
            {{ t('home.ctaButton') }}
          </NuxtLink>
        </div>
      </div>
    </section>
  </div>
</template>
